export const MAP_LITE_THRESHOLD = 500000;

export const AWS_ACCOUNT_ID_DEFAULT = "000000000000";